export const getSource = (): 'web' | 'mobile' => {
  const isMobile =
    typeof window !== 'undefined' &&
    /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);

  const source = isMobile ? 'mobile' : 'web';
  return source;
};
